module.exports = __webpack_public_path__ + "img/9.7255cdd0.jpg";